(() => {
  const cache=new Map();
  const option = item => (item.options_with_values || []).find(o=>o.name==='Choose Product')?.value;
  const data = item => {
    const url=new URL(item.url,location.origin);
    const handle=url.pathname.split('/products/')[1]?.split('/')[0];
    if(!handle)return Promise.resolve({label:item.product_type || '',short_title:item.product_title});
    if(!cache.has(handle)){
      url.searchParams.set('section_id','mc-product-choice-data');
      url.searchParams.set('preview_theme_id',String(window.Shopify.theme.id));
      cache.set(handle,fetch(url.href,{headers:{Accept:'text/html'}}).then(response=>{
        if(!response.ok)throw Error('Product choice unavailable');return response.text();
      }).then(html=>{
        const node=new DOMParser().parseFromString(html,'text/html').querySelector('[data-mc-product-choice-data]');
        if(!node)throw Error('Product choice data missing');return JSON.parse(node.textContent);
      }).catch(error=>{cache.delete(handle);throw error;}));
    }
    return cache.get(handle);
  };
  const populate = (item,typeNode,titleNode) => {
    const exact=option(item);
    typeNode.textContent=exact || item.product_type || '';
    data(item).then(result=>{
      if(!typeNode.isConnected)return;
      typeNode.textContent=exact || result.label;
      if(titleNode && result.short_title)titleNode.textContent=result.short_title;
    }).catch(()=>{});
  };
  const renderOptions = (container,item) => {
    container.replaceChildren();
    const typeRow=document.createElement('li');typeRow.className='mc-cart-type';
    const label=document.createElement('b');label.textContent=container.dataset.mcTypeLabel+': ';
    const value=document.createElement('span');value.dataset.mcTypeValue='';typeRow.append(label,value);container.append(typeRow);
    for(const o of item.options_with_values || []){
      if(o.name==='Choose Product' || !o.value || o.value==='Default Title')continue;
      const row=document.createElement('li'),name=document.createElement('b');name.textContent=o.name+': ';row.append(name,document.createTextNode(o.value));container.append(row);
    }
    return value;
  };
  window.mcCartType={option,data,populate,renderOptions};
})();
